import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  FootballLoadPreviousLineupMutation,
  FootballLoadPreviousLineupMutationVariables,
} from './__generated__/useLoadPreviousLineup.graphql.ts';

const LOAD_PREVIOUS_LINEUP_MUTATION = gql`
  mutation FootballLoadPreviousLineupMutation(
    $input: loadPreviousLineupInput!
    $so5LeaderboardSlug: String!
  ) {
    loadPreviousLineup(input: $input) {
      so5LeaderboardContender {
        slug
        so5Lineup {
          id
          so5Appearances {
            id
            anyCard {
              slug
              concurrentSo5Lineups(so5LeaderboardSlug: $so5LeaderboardSlug) {
                id
              }
            }
          }
        }
        managerTeam {
          id
        }
        so5Leaderboard {
          slug
          so5Fixture {
            slug
            mySo5LineupsCount
            so5LeaderboardGroups {
              slug
              eligibleCardsCountByPosition {
                slug
                position
                seasonality
                totalCount
                usedCardsCount
              }
            }
          }
          so5League {
            id
            slug
            mySo5LeaderboardContenders {
              slug
            }
            so5LeagueTracks {
              slug
              so5Leaderboards {
                slug
                mySo5LeaderboardContenders(includeHiddenManagerTeam: true) {
                  slug
                  so5Lineup {
                    id
                  }
                }
              }
            }
          }
          so5LeaderboardGroup {
            slug
            mySo5LeaderboardContenders {
              slug
            }
            so5LeagueTracks {
              slug
              so5Leaderboards {
                slug
                mySo5LeaderboardContenders(includeHiddenManagerTeam: true) {
                  slug
                  so5Lineup {
                    id
                  }
                }
              }
            }
          }
        }
      }
      currentUser {
        slug
        forcedIntoOnboarding
        blockchainCardsInLineups
      }
      errors {
        path
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  FootballLoadPreviousLineupMutation,
  FootballLoadPreviousLineupMutationVariables
>;

export const useLoadPreviousLineup = () => {
  return useMutation(LOAD_PREVIOUS_LINEUP_MUTATION, {
    showErrorsWithSnackNotification: true,
  });
};
